import ComisionMultiCreate from './ComisionMultiCreate'
export {ComisionMultiCreate}
export default ComisionMultiCreate
